"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const HiringProcess_1 = require("./HiringProcess");
exports.default = HiringProcess_1.HiringProcess;
